import { render, staticRenderFns } from "./chooseAutoSeries.vue?vue&type=template&id=166bf38c&scoped=true&"
import script from "./chooseAutoSeries.vue?vue&type=script&lang=js&"
export * from "./chooseAutoSeries.vue?vue&type=script&lang=js&"
import style0 from "./chooseAutoSeries.vue?vue&type=style&index=0&lang=css&"
import style1 from "./chooseAutoSeries.vue?vue&type=style&index=1&id=166bf38c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166bf38c",
  null
  
)

component.options.__file = "chooseAutoSeries.vue"
export default component.exports